<template>
    <div id="go-checkin-review-content">
        <vs-col class="w-2/3 pr-6" v-if="gocheckinReviewList.length != 0">
          <div v-for="(review, index) in gocheckinReviewList" :key="index">
            <item-go-checkin-review :reviewData="review"></item-go-checkin-review>
          </div>
          <div class="my-3" v-if="reviewData._meta.pageCount && reviewData._meta.pageCount > 1">
            <custom-pagination class="custom-pagination mt-6" :totalPages="parseInt(reviewData._meta.pageCount)" :currentPage="curPage" @pageChanged="changePage" :key="page_key"></custom-pagination>
          </div>
        </vs-col>

        <vs-col class="w-2/3 pr-6 text-center mt-base" v-else>
            No data available
        </vs-col>

        <vs-col class="w-1/3 right-col" v-if="reviewReport">
            <vx-card class="mb-6 mt-3">
              <div class="text-xl mb-6 flex align-center justify-between">
                <span class="card-title font-semibold color-black">Total Survey Send Out</span>
                <span class="text-25xl font-bold ml-3 color-black">{{reviewReport.total_survey}}</span>
              </div>
              <div class="w-full review-chart" v-if="isLoaded">
                <vue-apex-charts type='radialBar' height='240' :options="chartOptions" :series="series" />
              </div>
              <div>
                <div class="flex align-center justify-between">
                  <div>
                    <div class="div-color"></div>
                  </div>
                  <div
                    class="text-sm px-4 pr-3 color-black"
                  >Number Of Customers Writing Reviews Into Go Check In System</div>
                  <div class="text-2xl text-right font-bold color-black">{{reviewReport.customer_write_review_into_system}}</div>
                </div>
              </div>
            </vx-card>
            <vx-card class="mb-6">
              <div>
                <p class="text-xl mb-6 card-title font-semibold color-black">Customers Gave Ratings Into Go Check In System</p>
                <!-- <div class="flex align-center mb-2">
                  <span class="cursor-pointer"><vs-icon icon="sentiment_very_satisfied" size="medium" @click="emotionalFilter(5)"></vs-icon></span>
                  <span class="text-xl ml-5">{{reviewReport.customer_give_rating_into_system.five_star}} Clicks</span>
                </div>
                <div class="flex align-center mb-2">
                  <span class="cursor-pointer"><vs-icon icon="sentiment_dissatisfied" size="medium" @click="emotionalFilter(3)"></vs-icon></span>
                  <span class="text-xl ml-5">{{reviewReport.customer_give_rating_into_system.three_star}} Clicks</span>
                </div>
                <div class="flex align-center mb-2">
                  <span class="cursor-pointer"><vs-icon icon="sentiment_very_dissatisfied" size="medium" @click="emotionalFilter(1)"></vs-icon></span>
                  <span class="text-xl ml-5">{{reviewReport.customer_give_rating_into_system.one_star}} Clicks</span>
                </div> -->
                <div class="emotional-container">
                  <div class="emotional-item">
                      <div class="emotional-icon">
                          <vs-button class="emotional-btn very-unhappy emotional-active" @click="emotionalFilter(1)">
                              <span></span>
                              <div class="content" v-if="reviewReport.customer_give_rating_into_system.one_star">{{reviewReport.customer_give_rating_into_system.one_star}} Clicks</div>
                              <div class="content" v-else>0 Clicks</div>
                          </vs-button>
                      </div>
                  </div>
                  <div class="emotional-item">
                      <div class="emotional-icon">
                          <vs-button class="emotional-btn unhappy emotional-active" @click="emotionalFilter(2)">
                              <span></span>
                              <div class="content" v-if="reviewReport.customer_give_rating_into_system.two_star">{{reviewReport.customer_give_rating_into_system.two_star}} Clicks</div>
                              <div class="content" v-else>0 Clicks</div>
                          </vs-button>
                      </div>
                  </div>

                  <div class="emotional-item">
                      <div class="emotional-icon">
                          <vs-button class="emotional-btn normal emotional-active" @click="emotionalFilter(3)">
                              <span></span>
                              <div class="content" v-if="reviewReport.customer_give_rating_into_system.three_star">{{reviewReport.customer_give_rating_into_system.three_star}} Clicks</div>
                              <div class="content" v-else>0 Clicks</div>
                          </vs-button>
                      </div>
                  </div>

                  <div class="emotional-item">
                      <div class="emotional-icon">
                          <vs-button class="emotional-btn happy emotional-active" @click="emotionalFilter(4)">
                              <span></span>
                              <div class="content" v-if="reviewReport.customer_give_rating_into_system.four_star">{{reviewReport.customer_give_rating_into_system.four_star}} Clicks</div>
                              <div class="content" v-else>0 Clicks</div>
                          </vs-button>
                      </div>
                  </div>

                  <div class="emotional-item">
                      <div class="emotional-icon">
                          <vs-button class="emotional-btn very-happy emotional-active" @click="emotionalFilter(5)">
                              <span></span>
                              <div class="content" v-if="reviewReport.customer_give_rating_into_system.five_star">{{reviewReport.customer_give_rating_into_system.five_star}} Clicks</div>
                              <div class="content" v-else>0 Clicks</div>
                          </vs-button>
                      </div>
                  </div>
                </div>
              </div>
            </vx-card>
          </vs-col>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
    export default {
        name: 'go-checkin-review-content',
        components: {
          VueApexCharts
        },
        props: {
          search: {
            type: String
          },
          sort_by: {
            type: Object
          },
          currentPage: {
            type: Number,
            default: 1
          },
          itemsPerPage: {
            type: Number
          },
          filterRating: {
            type: Number
          }
        },
        data() {
          const obj = {
            page: this.currentPage,
            "per-page": this.itemsPerPage,
            type: 'gocheckin'
          }
          if(this.filterRating != 0) {
            obj.rating = this.filterRating;
          } else {
            if(this.sort_by && this.sort_by.id != 0) {
              obj.sort = this.sort_by.value;
            }
            obj.user_name = this.search;
          }
          this.$store.dispatch("reviewList/GET_REVIEW_LIST", obj).then(() => {
            this.$emit('GetDataComplete');
          });


          let isLoaded = false;
          let chartOptions = this.$store.getters['reviewList/chartOptions'];

          let series = [];
          let data = this.$store.getters['reviewList/reviewReport'];
          if(data && data.total_survey > 0) {
            let ratio = (parseInt(data.customer_write_review_into_system) / parseInt(data.total_survey) * 100).toFixed(1);
            series.push(ratio);
            isLoaded = true;
          }
          return {
            curPage: this.currentPage,
            isLoaded,
            chartOptions,
            series,
            isOpenLoading: false,
            page_key: 0
          }
        },
        methods: {
          openLoadingInDiv(){
            this.$vs.loading({
              container: '#list-review',
              scale: 0.8
            })
            if (this.loadTime) {
              clearTimeout(this.loadTime);
              this.loadTime = null;
            }
            this.isOpenLoading = true;
            this.loadTime = setTimeout( ()=> {
              if(this.isOpenLoading) {
                this.closeLoading();
                this.$vs.dialog({
                  color: 'danger',
                  title: 'Notification',
                  text: 'Get list go checkin review failed',
                  acceptText: 'OK'
                })
              }
            }, 10000);
          },
          closeLoading() {
            this.$vs.loading.close('#list-review > .con-vs-loading');
            this.isOpenLoading = false;
          },
          changePage(curPage) {
              const obj = {
                  page: curPage,
                  "per-page": this.itemsPerPage,
                  type: 'gocheckin'
              }

              if(this.filterRating) {
                obj.rating = this.filterRating;
              } else {
                if(this.sort_by && this.sort_by.id != 0) {
                  obj.sort = this.sort_by.value;
                }
                obj.user_name = this.search;
              }
              if(!this.isOpenLoading) {
                this.openLoadingInDiv();
              }
              this.$store.dispatch("reviewList/GET_REVIEW_LIST", obj).then(() => {
                this.closeLoading();
                this.$emit('ChangePage', curPage);
                this.page_key++;
              })
          },
          emotionalFilter(rating) {
            const obj = {
              page: this.currentPage,
              "per-page": this.itemsPerPage,
              type: 'gocheckin'
            }
            if(this.filterRating != 0) {
              obj.rating = this.filterRating;
            } else {
              if(this.sort_by && this.sort_by.id != 0) {
                obj.sort = this.sort_by.value;
              }
              obj.user_name = this.search;
            }
            if(!this.isOpenLoading) {
              this.openLoadingInDiv();
            }
            this.$store.dispatch("reviewList/GET_REVIEW_LIST", obj).then(() => {
              this.closeLoading();
              this.$emit('EmotionalFilter', rating);
            })
          }
        },
        computed: {
          gocheckinReviewList() {
            return this.$store.getters["reviewList/reviewList"];
          },
          reviewData() {
            return this.$store.getters["reviewList/reviewData"];
          },
          reviewReport() {
            return this.$store.getters['reviewList/reviewReport'];
          }
        },
        created() {
          this.$emit('ChangeReview', 'gocheckin');
        }
    }
</script>
